function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import pathOr from 'ramda/src/pathOr';
import createWizardActions from '../helpers/offer.ordering.wizard.action.helper';
import { ContextOfferingAction, TRANSITION_WIZARD_PREFIX } from '../constants/wizard.constants';
import { INVOICE_TIMING_CONSTANTS, NOTIFICATION_TIME_LENGTH } from '../../customercare.constants';
import { RemoveOfferReasonCodes } from './../constants/transition.offer.wizard.constants';
import { calculateChangeOfServiceOfferingOrderQuotePromise, retrieveOfferingContextPromiseWithOptions, setSelectedInventoryStores } from '../actions/offering.order.actions';
import i18n from 'invision-core/src/components/i18n/i18n';
import { getUiNotificationService } from 'invision-core/src/components/injectables/injector.helper';
import CustomerCareKeys from '../../locales/keys';
import metadataThunkHelper from 'invision-core/src/api/metadata.thunk.helper';
import ThunkHelper from 'invision-core/src/api/thunk.helper';
import { SUBSCRIBER_ID_HEADER, LANGUAGE_HEADER } from 'invision-core/src/api/constants';
var wizardActions = createWizardActions(TRANSITION_WIZARD_PREFIX);
export var BEGIN_TRANSITION_OFFER_ORDER = 'BEGIN_TRANSITION_OFFER_ORDER';
export var CANCEL_ORDER = wizardActions.CANCEL_WIZARD;
export var CHANGE_OFFER_STEP_SET_COMPLETED_STEPS = 'CHANGE_OFFER_STEP_SET_COMPLETED_STEPS';
export var GO_TO_NEXT_STEP = wizardActions.GO_TO_NEXT_STEP;
export var GO_TO_PREVIOUS_STEP = wizardActions.GO_TO_PREVIOUS_STEP;
export var GO_TO_STEP = wizardActions.GO_TO_STEP;
export var RESUME_ORDER_SET_SELECTED_OFFER_ID = 'RESUME_ORDER_SET_SELECTED_OFFER_ID';
export var RESTORE_OPTION_DEFAULT_PRICING = wizardActions.RESTORE_OPTION_DEFAULT_PRICING;
export var RETRIEVE_ADDRESSES = wizardActions.RETRIEVE_ADDRESSES;
export var SEND_PORT_IN_OR_ITEM_RESERVATION = wizardActions.SEND_PORT_IN_OR_ITEM_RESERVATION;
export var SET_ATTRIBUTE_SEARCHING_INVENTORY = wizardActions.SET_ATTRIBUTE_SEARCHING_INVENTORY;
export var SAVE_OPTION_PRICING = wizardActions.SAVE_OPTION_PRICING;
export var SET_CURRENT_STEP_IS_INVALID = wizardActions.SET_CURRENT_STEP_IS_INVALID;
export var SET_EDIT_ATTRIBUTE_GROUPS = wizardActions.SET_EDIT_ATTRIBUTE_GROUPS;
export var SET_EDIT_OPTION = wizardActions.SET_EDIT_OPTION;
export var SET_EDIT_CART_ADDITIONAL_PROPERTY = wizardActions.SET_EDIT_CART_ADDITIONAL_PROPERTY;
export var SET_EDIT_CART_ADDITIONAL_PROPERTY_ON_CHANGE = wizardActions.SET_EDIT_CART_ADDITIONAL_PROPERTY_ON_CHANGE;
export var SET_EDIT_ORDER_ADDITIONAL_PROPERTY = wizardActions.SET_EDIT_ORDER_ADDITIONAL_PROPERTY;
export var SET_EDIT_ORDER_ADDITIONAL_PROPERTY_ON_CHANGE = wizardActions.SET_EDIT_ORDER_ADDITIONAL_PROPERTY_ON_CHANGE;
export var SET_EDIT_PHYSICAL_ATTRIBUTE_GROUPS = wizardActions.SET_EDIT_PHYSICAL_ATTRIBUTE_GROUPS;
export var SET_PAYMENT_INFO = wizardActions.SET_PAYMENT_INFO;
export var SET_SELECTED_FACETS_EDIT_COPY = wizardActions.SET_SELECTED_FACETS_EDIT_COPY;
export var SET_SELECTED_OFFERING_CHARGE_TYPES_EDIT_COPY = wizardActions.SET_SELECTED_OFFERING_CHARGE_TYPES_EDIT_COPY;
export var SET_SELECTED_OFFER = wizardActions.SET_SELECTED_OFFER;
export var SET_SELECTED_OFFER_EDIT_COPY = wizardActions.SET_SELECTED_OFFER_EDIT_COPY;
export var SET_SELECTED_WIZARD_TAB = wizardActions.SET_SELECTED_WIZARD_TAB;
export var UPDATE_EDIT_BRI_PRICE = wizardActions.UPDATE_EDIT_BRI_PRICE;
export var UPDATE_INVENTORY_SELECTION = wizardActions.UPDATE_INVENTORY_SELECTION;
export var UPDATE_OFFER_ATTRIBUTE = wizardActions.UPDATE_OFFER_ATTRIBUTE;
export var UPDATE_OFFER_PHYSICAL_INVENTORY_MAKE_AND_MODEL = wizardActions.UPDATE_OFFER_PHYSICAL_INVENTORY_MAKE_AND_MODEL;
export var UPDATE_OFFER_PHYSICAL_INVENTORY_TYPE_ATTRIBUTE = wizardActions.UPDATE_OFFER_PHYSICAL_INVENTORY_TYPE_ATTRIBUTE;
export var UPDATE_SELECTED_SERVICE_FEATURES = wizardActions.UPDATE_SELECTED_SERVICE_FEATURES;
export var UPDATE_PAYMENT_INFO = wizardActions.UPDATE_PAYMENT_INFO;
export var UPDATE_PORT_IN_REQUEST = wizardActions.UPDATE_PORT_IN_REQUEST;
export var cancelOrder = wizardActions.cancelWizard;
export var clearQuoteAndSetSelectedOffer = wizardActions.clearQuoteAndSetSelectedOffer;
export var fetchAddresses = wizardActions.fetchAddresses;
export var fetchAttributes = wizardActions.fetchAttributes;
export var fetchWallet = wizardActions.fetchWallet;
export var goToNextStep = wizardActions.goToNextStep;
export var goToPreviousStep = wizardActions.goToPreviousStep;
export var goToStep = wizardActions.goToStep;
export var restoreOptionDefaultPricing = wizardActions.restoreOptionDefaultPricing;
export var saveBulkPricing = wizardActions.saveBulkPricing;
export var searchAttributeInventory = wizardActions.searchAttributeInventory;
export var sendPortInOrItemReservation = wizardActions.sendPortInOrItemReservation;
export var setCurrentStepIsInvalid = wizardActions.setCurrentStepIsInvalid;
export var setEditAttributeGroups = wizardActions.setEditAttributeGroups;
export var setEditOption = wizardActions.setEditOption;
export var setEditCartAdditionalProperty = wizardActions.setEditCartAdditionalProperty;
export var setEditCartAdditionalPropertyOnChange = wizardActions.setEditCartAdditionalPropertyOnChange;
export var setEditOrderAdditionalProperty = wizardActions.setEditOrderAdditionalProperty;
export var setEditOrderAdditionalPropertyOnChange = wizardActions.setEditOrderAdditionalPropertyOnChange;
export var setEditPhysicalAttributeGroups = wizardActions.setEditPhysicalAttributeGroups;
export var setPaymentInfo = wizardActions.setPaymentInfo;
export var setSelectedFacetsEditCopy = wizardActions.setSelectedFacetsEditCopy;
export var setSelectedOffer = wizardActions.setSelectedOffer;
export var setSelectedOfferingChargeTypesEditCopy = wizardActions.setSelectedOfferingChargeTypesEditCopy;
export var setSelectedOfferEditCopy = wizardActions.setSelectedOfferEditCopy;
export var setSelectedTab = wizardActions.setSelectedTab;
export var updateAttribute = wizardActions.updateAttribute;
export var updateBillCycle = wizardActions.updateBillCycle;
export var updateCart = wizardActions.updateCart;
export var updateEditOptionPrice = wizardActions.updateEditOptionPrice;
export var updateInventorySelection = wizardActions.updateInventorySelection;
export var updateOfferPhysicalInventoryMakeAndModel = wizardActions.updateOfferPhysicalInventoryMakeAndModel;
export var updateOfferPhysicalInventoryTypeAttribute = wizardActions.updateOfferPhysicalInventoryTypeAttribute;
export var updateSelectedServiceFeatures = wizardActions.updateSelectedServiceFeatures;
export var updatePaymentInfo = wizardActions.updatePaymentInfo;
export var updatePortInRequest = wizardActions.updatePortInRequest;
export var fetchAttributesQuoteAndNavigate = function fetchAttributesQuoteAndNavigate(customerInfo, offeringId) {
  var completedDecisions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var completedAttributes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var completedPhysicalAttributes = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var transitionContext = arguments.length > 5 ? arguments[5] : undefined;
  var isAsync = arguments.length > 6 ? arguments[6] : undefined;
  var isShipping = arguments.length > 7 ? arguments[7] : undefined;
  var skipGoToNextStep = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : false;
  var transitionOfferingInstanceId = arguments.length > 9 ? arguments[9] : undefined;
  var bypassQuote = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : false;
  return function (dispatch) {
    return transitionRetrievePreviousAttributesPromise(dispatch, customerInfo.Id, offeringId, completedDecisions.concat(completedAttributes).concat(completedPhysicalAttributes), transitionContext).then(function (response) {
      return calculateChangeOfServiceOfferingOrderQuotePromise(dispatch, customerInfo, transitionOfferingInstanceId, response.AddItems, response.RemoveItems, response.ModifyItems, undefined, undefined, undefined, isShipping, bypassQuote).then(function () {
        if (skipGoToNextStep) {
          dispatch(goToNextStep());
        }
      }).catch(function (error) {
        getUiNotificationService().error(error.translatedMessage, null, {
          timeOut: NOTIFICATION_TIME_LENGTH
        });
      });
    }).catch(function (error) {
      if (!pathOr([], ['FaultData'], error).length) {
        getUiNotificationService().error(error.translatedMessage !== error.Code.toString() ? error.translatedMessage : i18n.translate(CustomerCareKeys.QUOTE_ERROR), null, {
          timeOut: NOTIFICATION_TIME_LENGTH
        });
      }
    });
  };
};
export var fetchPreviousAttributesAndNavigate = function fetchPreviousAttributesAndNavigate(customerInfo, offerId, completedDecisions, transitionContext, fromOfferId, offeringInstanceId, isConvergentBiller, isAsync) {
  var bypassQuote = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : false;
  return function (dispatch) {
    // Disallow the user from submitting again until the request is done
    dispatch(setCurrentStepIsInvalid(true));
    return transitionRetrievePreviousAttributesPromise(dispatch, customerInfo.Id, offerId, completedDecisions, transitionContext, isConvergentBiller).then(function (response) {
      return handleROCPreviousAttributesResponse(dispatch, response, customerInfo, offerId, fromOfferId, offeringInstanceId, isAsync, bypassQuote);
    }).catch(function (error) {
      getUiNotificationService().error(error.translatedMessage !== error.Code.toString() ? error.translatedMessage : i18n.translate(CustomerCareKeys.DECISIONS_ERROR), null, {
        timeOut: NOTIFICATION_TIME_LENGTH
      });
    });
  };
};
var handleROCPreviousAttributesResponse = function handleROCPreviousAttributesResponse(dispatch, response, customerInfo, offerId) {
  var fromOfferId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var offeringInstanceId = arguments.length > 5 ? arguments[5] : undefined;
  var isAsync = arguments.length > 6 ? arguments[6] : undefined;
  var bypassQuote = arguments.length > 7 ? arguments[7] : undefined;
  response.Context.ValueDecisions.filter(function (decision) {
    // if there is a DependentServiceAttributeId then the attribute is hidden
    // if they are all hidden, then we don't need to show attributes page
    return !decision.DependentServiceAttributeId;
  });
  dispatch(setCurrentStepIsInvalid(false));
  if (response.Context.ValueDecisions.length > 0 || response.Context.PhysicalInventoryDecisions && response.Context.PhysicalInventoryDecisions.length > 0) {
    dispatch(goToStep(CustomerCareKeys.WIZARD.STEPS.ATTRIBUTES));
  } else {
    return calculateChangeOfServiceOfferingOrderQuotePromise(dispatch, customerInfo, offerId, response.AddItems, response.ModifyItems, response.RemoveItems, undefined, undefined, undefined, undefined, bypassQuote).then(function () {
      dispatch(goToStep(CustomerCareKeys.WIZARD.STEPS.CHECKOUT));
    });
  }
};
export var TRANSITION_RETRIEVE_PREVIOUS_ATTRIBUTES = {
  BEGIN: 'TRANSITION_RETRIEVE_PREVIOUS_ATTRIBUTES_BEGIN',
  SUCCESS: 'TRANSITION_RETRIEVE_PREVIOUS_ATTRIBUTES_SUCCESS',
  FAILURE: 'TRANSITION_RETRIEVE_PREVIOUS_ATTRIBUTES_FAILURE'
};
var TRANSITION_RETRIEVE_PREVIOUS_ATTRIBUTES_TYPES = [TRANSITION_RETRIEVE_PREVIOUS_ATTRIBUTES.BEGIN, TRANSITION_RETRIEVE_PREVIOUS_ATTRIBUTES.SUCCESS, TRANSITION_RETRIEVE_PREVIOUS_ATTRIBUTES.FAILURE];
export var beginTransitionOfferOrder = function beginTransitionOfferOrder() {
  return {
    type: BEGIN_TRANSITION_OFFER_ORDER
  };
};
var transitionRetrievePreviousAttributesPromise = function transitionRetrievePreviousAttributesPromise(dispatch, customerId, offeringId) {
  var completedDecisions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var transitionContext = arguments.length > 4 ? arguments[4] : undefined;
  var isConvergentBiller = arguments.length > 5 ? arguments[5] : undefined;
  return ThunkHelper(dispatch, TRANSITION_RETRIEVE_PREVIOUS_ATTRIBUTES_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveOfferingContext',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
    data: {
      Offerings: [{
        Action: ContextOfferingAction.TRANSITION,
        OfferingId: offeringId
      }],
      AdditionalShoppingCartUpdate: !isConvergentBiller,
      RetrieveServiceAttributes: true,
      RetrieveDeliveryDecisions: true,
      RetrievePhysicalInventoryDecisions: true,
      CompletedDecisionsList: completedDecisions,
      TransitionOutcomes: transitionContext.Outcomes
    }
  });
};
export var RETRIEVE_TRANSITION_CONTEXT = {
  BEGIN: 'RETRIEVE_TRANSITION_CONTEXT.BEGIN',
  SUCCESS: 'RETRIEVE_TRANSITION_CONTEXT.SUCCESS',
  FAILURE: 'RETRIEVE_TRANSITION_CONTEXT.FAILURE'
};
var RETRIEVE_TRANSITION_CONTEXT_CONSTANTS = [RETRIEVE_TRANSITION_CONTEXT.BEGIN, RETRIEVE_TRANSITION_CONTEXT.SUCCESS, RETRIEVE_TRANSITION_CONTEXT.FAILURE];
export var retrieveTransitionContextPromise = function retrieveTransitionContextPromise(dispatch, customerId, offeringId, fromOfferingId, offeringInstanceId) {
  var reqBody = {
    ExistingOfferingId: fromOfferingId,
    ExistingOfferingInstanceId: offeringInstanceId,
    Offerings: [{
      Action: ContextOfferingAction.TRANSITION_REQUEST,
      OfferingId: offeringId
    }]
  };
  return ThunkHelper(dispatch, RETRIEVE_TRANSITION_CONTEXT_CONSTANTS, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveTransitionContext',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
    data: reqBody
  });
};
export var retrieveTransitionContext = function retrieveTransitionContext(customerId, offeringId, fromOfferingId, offeringInstanceId) {
  return function (dispatch) {
    return retrieveTransitionContextPromise(dispatch, customerId, offeringId, fromOfferingId, offeringInstanceId).catch(function (errorPayload) {
      getUiNotificationService.error(errorPayload.translatedMessage, null, {
        timeOut: NOTIFICATION_TIME_LENGTH
      });
    });
  };
};
var GET_TRANSITION_OFFERING_METADATA = {
  BEGIN: 'GET_TRANSITION_OFFERING_METADATA_BEGIN',
  SUCCESS: 'GET_TRANSITION_OFFERING_METADATA_SUCCESS',
  FAILURE: 'GET_TRANSITION_OFFERING_METADATA_FAILURE'
};
var GET_TRANSFER_OFFERING_METADATA_EVENTS = [GET_TRANSITION_OFFERING_METADATA.BEGIN, GET_TRANSITION_OFFERING_METADATA.SUCCESS, GET_TRANSITION_OFFERING_METADATA.FAILURE];
var getTransitionOfferingMetadataPromise = function getTransitionOfferingMetadataPromise(dispatch, offeringId, language) {
  return metadataThunkHelper(dispatch, GET_TRANSFER_OFFERING_METADATA_EVENTS, {
    url: "Offering/Id/".concat(offeringId),
    headers: _defineProperty({}, LANGUAGE_HEADER, language || undefined)
  });
};
export var getTransitionOfferingMetadata = function getTransitionOfferingMetadata(offeringId, language) {
  return function (dispatch) {
    return getTransitionOfferingMetadataPromise(dispatch, offeringId, language);
  };
};
export var SET_TRANSITION_OFFERINGS_METADATA = 'SET_TRANSITION_OFFERINGS_METADATA';
export var setTransitionOfferingsMetadata = function setTransitionOfferingsMetadata(offeringsMetadata) {
  return {
    payload: offeringsMetadata,
    type: SET_TRANSITION_OFFERINGS_METADATA
  };
};
export var TRANSITION_SUBMIT_COS_ORDER = {
  BEGIN: 'TRANSITION_SUBMIT_COS_ORDER_BEGIN',
  SUCCESS: 'TRANSITION_SUBMIT_COS_ORDER_SUCCESS',
  FAILURE: 'TRANSITION_SUBMIT_COS_ORDER_FAILURE'
};
var TRANSITION_SUBMIT_COS_ORDER_TYPES = [TRANSITION_SUBMIT_COS_ORDER.BEGIN, TRANSITION_SUBMIT_COS_ORDER.SUCCESS, TRANSITION_SUBMIT_COS_ORDER.FAILURE];
export var transitionOfferSubmitCosOrder = function transitionOfferSubmitCosOrder(customerId, offeringId, addItems, modifyItems, removeItems, paymentInfo) {
  var fromOfferId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
  var changesEffective = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
  var executionOptions = arguments.length > 8 ? arguments[8] : undefined;
  var recordPaymentInformation = arguments.length > 9 ? arguments[9] : undefined;
  var subscriberPhysicalInventoryPickupDetail = arguments.length > 10 ? arguments[10] : undefined;
  var additionalProperties = arguments.length > 11 ? arguments[11] : undefined;
  var shippingInfo = arguments.length > 12 ? arguments[12] : undefined;
  return function (dispatch) {
    return transitionOfferSubmitCosOrderPromise(dispatch, customerId, offeringId, addItems, modifyItems, removeItems, paymentInfo, fromOfferId, changesEffective, executionOptions, recordPaymentInformation, subscriberPhysicalInventoryPickupDetail, additionalProperties, shippingInfo);
  };
};
export var transitionOfferSubmitCosOrderPromise = function transitionOfferSubmitCosOrderPromise(dispatch, customerId, offeringId, addItems, modifyItems, removeItems, paymentInfo) {
  var fromOfferId = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
  var changesEffective = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
  var executionOptions = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : {};
  var recordPaymentInformation = arguments.length > 10 ? arguments[10] : undefined;
  var subscriberPhysicalInventoryPickupDetail = arguments.length > 11 ? arguments[11] : undefined;
  var additionalProperties = arguments.length > 12 ? arguments[12] : undefined;
  var shippingInfo = arguments.length > 13 ? arguments[13] : undefined;
  var paymentInfoArray = paymentInfo ? [paymentInfo] : [];
  var reqBody = {
    AddItems: addItems,
    AdditionalProperties: additionalProperties || null,
    ChangeImmediately: true,
    ExecutionDate: executionOptions.specifiedDate,
    ExecutionDateIntention: executionOptions.effective,
    ModifyItems: modifyItems,
    RecordPaymentInformation: recordPaymentInformation,
    RemoveItems: removeItems,
    PaymentInstruments: paymentInfoArray,
    PickupId: subscriberPhysicalInventoryPickupDetail,
    ShippingAddressId: shippingInfo.addressId || undefined,
    ShippingMethodId: shippingInfo.methodId || undefined,
    ShipToName: shippingInfo.shipTo || undefined
  };
  if (fromOfferId) {
    reqBody.OfferingId = fromOfferId;
  }
  if (offeringId) {
    reqBody.TransitionOfferingId = offeringId;
  }
  if (+changesEffective === INVOICE_TIMING_CONSTANTS.INVOICE_ON_CYCLE) {
    reqBody.ChangeImmediately = false;
  }
  if (removeItems.length) {
    reqBody.RemoveReasonCode = RemoveOfferReasonCodes.DefaultedToRemove;
  }
  return ThunkHelper(dispatch, TRANSITION_SUBMIT_COS_ORDER_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/SubmitChangeOfServiceOrder',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
    data: reqBody
  });
};
export var fetchDecisionsAndNavigate = function fetchDecisionsAndNavigate(offerId, customerInfo, options) {
  var fromOfferId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var offeringInstanceId = arguments.length > 4 ? arguments[4] : undefined;
  var isAsync = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  var bypassQuote = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  var transitionContext = options.transitionContext,
    isConvergentBiller = options.isConvergentBiller,
    segmentationContext = options.segmentationContext = [],
    grandfatherPricingPlans = options.grandfatherPricingPlans || true;
  return function (dispatch) {
    // Set Offers step to invalid until the api call is successful
    dispatch(setCurrentStepIsInvalid(true));
    return retrieveOfferingContextPromiseWithOptions(dispatch, offerId, customerInfo.Id, {
      isConvergentBiller: isConvergentBiller,
      segmentationContext: segmentationContext,
      transitionContext: transitionContext,
      grandfatherPricingPlans: grandfatherPricingPlans
    }).then(function (response) {
      dispatch(setCurrentStepIsInvalid(false));
      if (response.Context.Decisions.length > 0) {
        dispatch(goToNextStep());
      } else {
        var completedDecisions = [];
        return transitionRetrievePreviousAttributesPromise(dispatch, customerInfo.Id, offerId, completedDecisions, transitionContext).then(function (response) {
          return handleROCPreviousAttributesResponse(dispatch, response, customerInfo, offerId, fromOfferId, offeringInstanceId, isAsync, bypassQuote);
        });
      }
    }).catch(function (error) {
      getUiNotificationService().error(error.translatedMessage, null, {
        timeOut: NOTIFICATION_TIME_LENGTH
      });
    });
  };
};
export var SET_IS_RESUMING_STORE_ORDER = 'SET_IS_RESUMING_STORE_ORDER';
export var setIsResumingStoreOrder = function setIsResumingStoreOrder(resumingOrder) {
  return {
    type: SET_IS_RESUMING_STORE_ORDER,
    payload: resumingOrder
  };
};
export var RESUME_STORE_ORDER_TRANSITION = {
  BEGIN: 'RESUME_STORE_ORDER_TRANSITION_BEGIN',
  SUCCESS: 'RESUME_STORE_ORDER_TRANSITION_SUCCESS',
  FAILURE: 'RESUME_STORE_ORDER_TRANSITION_FAILURE'
};
export var RESUME_STORE_ORDER_TRANSITION_EVENTS = [RESUME_STORE_ORDER_TRANSITION.BEGIN, RESUME_STORE_ORDER_TRANSITION.SUCCESS, RESUME_STORE_ORDER_TRANSITION.FAILURE];
var resumeStoreOrderTransitionPromise = function resumeStoreOrderTransitionPromise(dispatch, customerId) {
  return ThunkHelper(dispatch, RESUME_STORE_ORDER_TRANSITION_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/ResumeStoreOrder',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
    data: {
      RetrievePhysicalInventoryDecisions: false,
      RetrieveServiceAttributes: false
    }
  });
};
export var RESUME_STORE_ORDER_FOR_INVENTORY_AND_ATTRIBUTES_DECISIONS_FOR_TRANSITION = {
  BEGIN: 'RESUME_STORE_ORDER_FOR_INVENTORY_AND_ATTRIBUTES_DECISIONS_FOR_TRANSITION_BEGIN',
  SUCCESS: 'RESUME_STORE_ORDER_FOR_INVENTORY_AND_ATTRIBUTES_DECISIONS_FOR_TRANSITION_SUCCESS',
  FAILURE: 'RESUME_STORE_ORDER_FOR_INVENTORY_AND_ATTRIBUTES_DECISIONS_FOR_TRANSITION_FAILURE'
};
export var RESUME_STORE_ORDER_FOR_INVENTORY_AND_ATTRIBUTES_DECISIONS_FOR_TRANSITION_EVENTS = [RESUME_STORE_ORDER_FOR_INVENTORY_AND_ATTRIBUTES_DECISIONS_FOR_TRANSITION.BEGIN, RESUME_STORE_ORDER_FOR_INVENTORY_AND_ATTRIBUTES_DECISIONS_FOR_TRANSITION.SUCCESS, RESUME_STORE_ORDER_FOR_INVENTORY_AND_ATTRIBUTES_DECISIONS_FOR_TRANSITION.FAILURE];
var resumeStoreOrderPromise = function resumeStoreOrderPromise(dispatch, customerId) {
  return ThunkHelper(dispatch, RESUME_STORE_ORDER_FOR_INVENTORY_AND_ATTRIBUTES_DECISIONS_FOR_TRANSITION_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/ResumeStoreOrder',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
    data: {
      RetrievePhysicalInventoryDecisions: true,
      RetrieveServiceAttributes: true
    }
  });
};
export var resumeStoreOrderForTransition = function resumeStoreOrderForTransition(customerInfo, storeOrder) {
  return function (dispatch) {
    var fromOfferingId = storeOrder.SourceTransitionOfferingId;
    var offeringInstanceId = storeOrder.SourceTransitionOfferingInstanceId;
    var offeringId = pathOr(null, ['Context', 'OfferingIds', '0'], storeOrder);
    var storeId = storeOrder.ShoppingCart.Items.find(function (item) {
      return item.PhysicalInventories ? item.PhysicalInventories[0].StoreId : false;
    });
    dispatch(setSelectedOffer(offeringId));
    return resumeStoreOrderTransitionPromise(dispatch, customerInfo).then(function () {
      return resumeStoreOrderPromise(dispatch, customerInfo);
    }).then(function () {
      return dispatch(setSelectedInventoryStores([storeId.PhysicalInventories[0].StoreId.toString()]));
    }).then(function () {
      dispatch(setChangeOfferStepToCompletedSteps());
      return dispatch(goToStep(CustomerCareKeys.WIZARD.STEPS.DECISIONS));
    }).then(function () {
      return retrieveTransitionContextPromise(dispatch, customerInfo, offeringId, fromOfferingId, offeringInstanceId);
    }).then(function () {
      dispatch(setCurrentStepIsInvalid(false));
    }).catch(function (error) {
      getUiNotificationService().error(error.translatedMessage, null, {
        timeOut: NOTIFICATION_TIME_LENGTH
      });
    });
  };
};
export var setChangeOfferStepToCompletedSteps = function setChangeOfferStepToCompletedSteps() {
  return {
    type: CHANGE_OFFER_STEP_SET_COMPLETED_STEPS
  };
};
export var SET_SERVICE_TAX_LOCATION_DECISION_CHANGE_OFFER = 'SET_SERVICE_TAX_LOCATION_DECISION_CHANGE_OFFER';
export var updateServiceTaxLocationDecisionChangeOffer = function updateServiceTaxLocationDecisionChangeOffer(payload) {
  return {
    type: SET_SERVICE_TAX_LOCATION_DECISION_CHANGE_OFFER,
    payload: payload
  };
};